<template>
  <div v-if="solde" :class="jel_getClassObject(content)">
    <Titre
      :content="{
        type: content.type,
        titre: titreFormatte,
        classeCSS: 'text-center text-md-left mb-1 pt-1',
      }"
    >
    </Titre>
  </div>
</template>

<script>
import Titre from '@/components/base/Titre.vue';
import { formatNombreEnMonetaire, formatMonetaireEnNombre } from '@/helpers/StringHelpers';

export default {
  name: 'CompteTitreSolde',
  components: { Titre },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      solde: '',
    };
  },

  computed: {
    titreFormatte() {
      return this.content.titre.replace('{{solde}}', this.solde);
    },
  },
  mounted() {
    // On assume que get_session_details a été fait préalablement
    this.solde = getSolde();

    // Pour obtenir le solde de SB tokens, une solution "patch" est possible, mais reverted pour l'instant.
    // Disponible ici: https://gitlab.loto-quebec.com/espacejeux/mon-compte/-/commit/203e0739074572bcd40e7238d1d3bbdca507d245

    if (!this.solde) {
      const self = this;

      setTimeout(() => {
        self.solde = getSolde();
      }, 3000);
    }
  },
};

function getSolde() {
  try {
    // eslint-disable-next-line no-undef
    const soldePlusArgentBoniFormat = ejConnect.lireSoldePlusArgentBoniFormat();
    // Le solde est formaté en FR donc on récupère la valeur Numérique
    const soldeNombre = formatMonetaireEnNombre(soldePlusArgentBoniFormat);

    if (!soldeNombre) {
      return null;
    }
    if (soldeNombre > 0) {
      // On formate le solde au bon format monétaire
      return formatNombreEnMonetaire(soldeNombre);
    }
    return null;
  } catch (error) {
    return null;
  }
}
</script>
